import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {Link, LinkIcon, GetStartedInput, AboutBanner} from '../../components'
import container from '../../helpers/container'

import Styles from './CarbonUnderground200.css'

@CSSModules(Styles)
export default class CarbonUnderground200 extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'Carbon Underground 200'
    const description = "Get your money out of fossil fuels. Use Fossil Free Funds to find out if you're invested in the largest owners of carbon reserves."
    const url = config.domain + config.routes.carbonunderground200

    const bannerImage = 'smoke'
    const bannerHeadline = 'The Carbon Underground 200™'
    const bannerSubtitle = 'The top 200 coal and oil/gas reserve owners in the world'
    return (
      <div>
        {container.helmet(title, description, url)}
        <div styleName='image-banner-container'>
          <div styleName='image-banner-container-inner'>
            <div styleName={'image-banner-'+bannerImage}>
              <div styleName='image-banner-headline'>
                {bannerHeadline}
              </div>
              <div styleName='image-banner-subtitle'>
                {bannerSubtitle}
              </div>
            </div>
          </div>
        </div>
        <div styleName='page'>
          <div styleName='container'>
            <div styleName='container-inner'>
              <div styleName='title'>
                Find out if you're invested in 200 of the largest owners of carbon reserves
              </div>
              <p>
                The Carbon Underground 200&trade;, compiled and maintained by FFI Solutions (formerly Fossil Free Indexes℠), identifies the top 100 coal and the top 100 oil and gas publicly-traded reserve holders globally, ranked by the potential carbon emissions content of their reported reserves.
              </p>
              <p>
                Rankings are constructed using a reserves-based methodology with the underlying core data based on “reported” reserves. Coal reserves are the sum of proven and probable reserves based on the last reported reserves amount by mine. Reserves are allocated to listed companies based on percentage ownership of individual mines. Oil and gas companies are ranked on proven reserves (1P) net of royalty payments.
              </p>
              <p>
                The Carbon Underground 200&trade; relies on the IPCC Revised 1996 Guidelines for National Greenhouse Gas Inventories as a methodological framework. The calculation of CO2 emission potential requires several conversions to the raw reserves figure.
              </p>
              <p>
                <Link
                  to={config.links.fficu200}
                  xstrong
                  title='Carbon Underground 200 - FFI Solutions'
                >
                  Visit FFI Solutions online to learn more about licensing the full list of 200 companies<LinkIcon />
                </Link>
              </p>
            </div>
          </div>
          { /*
             * GET STARTED INPUT BANNER
             *
             */ }
          <GetStartedInput />
          <div styleName='x-ffi-wrap'>
            <div styleName='x-ffi-container'>
              <div styleName='x-ffi-container-inner'>
                <div styleName='x-ffi-info-photo'>
                  <div
                    styleName='x-ffi-photo'
                    title='FFI Solutions'
                  />
                  <div styleName='x-ffi-info'>
                    <div styleName='x-ffi-info-title'>
                      FFI Solutions
                    </div>
                    <p>
                      FFI Solutions (formerly Fossil Free Indexes℠) provides benchmarks, research and investment solutions that support carbon-responsible investing, with an initial focus on broad market indexes ex-fossil fuels that align with the divestment movement. Embracing the transition to a low carbon economy through responsible investing, they join the growing number of analysts who believe fossil fuel companies are overvalued and a risky long-term investment based on unburnable reserves. FFI Solutions indexes and rankings are licensed for funds, ETFs, and separate accounts, as the basis for investable products and strategies.
                    </p>
                    <p>
                      <Link
                        to={config.links.ffi}
                        xstrong
                        title='FFI Solutions'
                      >
                        Learn more at www.ffisolutions.com<LinkIcon />
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div styleName='x-disclaimer-wrap'>
            <div styleName='x-disclaimer-container'>
              <div styleName='x-disclaimer-container-inner'>
                <div styleName='x-disclaimer-info-photo'>
                  <div
                    styleName='x-disclaimer-photo'
                    title='Disclaimer'
                  />
                  <div styleName='x-disclaimer-info'>
                    <div styleName='x-disclaimer-info-title'>
                      Disclaimer
                    </div>
                    <p>
                      Mutual funds screened for Carbon Underground 200&trade; companies by Fossil Free Funds would flag the equities of only the reserve-owning corporate entities of Carbon Underground 200&trade; ranked companies. They would not flag non-reserve owning subsidiaries or parent companies. If reserve-owning subsidiaries are listed separately from their parent, and their reserves are reported separately from the parent, but their emissions do not merit inclusion in the Carbon Underground 200&trade;, the equities of those subsidiaries may not be flagged by screening. Given the continual mergers and acquisitions, closures, delisting, and IPO activities in the coal, oil, and gas industries, the Carbon Underground 200&trade; list represents a best-efforts attempt at researching listed companies and basing the analysis on the latest available information.
                    </p>
                  </div>
                </div>
                { /*
                   * ABOUT BANNER
                   *
                   */ }
                <AboutBanner/>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
